import './index-metric-querycache.style.scss'

class indexMetricQuerycacheController {

}

export default indexMetricQuerycacheController;



// WEBPACK FOOTER //
// ./ui/src/components/index-metric-querycache/index-metric-querycache.controller.js